import {useContext} from 'react';

import {Navigate, Outlet} from 'react-router-dom';

import {UserContext} from '../../contexts/UserContext/UserContext';
import {ROLE_APPLICANT} from '../../lib/constants';

export const ApplicantGuard = () => {
  const {currentUser, isLoading} = useContext(UserContext);

  if (isLoading || !currentUser) {
    return null;
  }

  return currentUser?.role.type === ROLE_APPLICANT ? <Outlet /> : <Navigate to={'/'} />;
};
